module.exports = __webpack_public_path__ + "img/plus.0ac961aa.png";